<template>
  <component
    :is="elementType"
    :class="[
      $style.section,
      {
        [$style['section--disabled']]: disabled,
        [$style['section--hidden-disabled-mobile']]: hiddenDisabledMobile && disabled,
      },
    ]"
    v-bind="{ ...$props, ...$listeners }"
  >
    <slot />
  </component>
</template>

<script>
export default {
  name: 'FormSection',
  props: {
    elementType: {
      type: String,
      default: 'section',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hiddenDisabledMobile: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" module>
$desktopViewBreakpoint: map-get($grid-breakpoints, 'md');
@import '~@/styles/utilities/_hide.scss';

.section {
  margin: 0;
  padding: 0;

  > *:last-child {
    margin-bottom: 0 !important;
  }

  &--disabled {
    cursor: not-allowed;

    user-select: none;

    pointer-events: none;
  }

  &--hidden-disabled-mobile {
    @media screen and (max-width: '#{$desktopViewBreakpoint - 1px}') {
      @include visually-hidden;
    }
  }
}

.section:not(:first-child) {
  margin-top: 3.75rem;
}
</style>
